import {
    Box,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    Select,
  } from '@material-ui/core'
import { LabelToText, ScheduleType } from '../../../../../../shared/src/data/scheduleType'
import { useSelectionStyles } from './selectionStyles'
import { RegionOfInterestColors } from '../pdfViewport/Colors'
  
  type LabelSelectionActionsProps = {
    setSelectedLabel: (label: ScheduleType) => void
    selectedLabel: ScheduleType
  }

  export default function LabelSelectionActions({
    setSelectedLabel,
    selectedLabel,
  }: LabelSelectionActionsProps) {
    const classes = useSelectionStyles()
    return (
      <>
        <Box className={classes.container}>
          <FormControl className={classes.formControl} fullWidth>
            <InputLabel id='label-select-label'>
              Label
            </InputLabel>
            <Select
              id='label-select'
              label='Label'
              value={selectedLabel}
              // Workaround a React bug
              MenuProps={{ getContentAnchorEl: null }}
              color='secondary'
              renderValue={(selected) => (
                <Box display="flex" alignItems="center">
                  <span
                    style={{
                      display: 'inline-block',
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      backgroundColor: RegionOfInterestColors[selected as ScheduleType] || 'white',
                      marginRight: '10px',
                    }}
                  />
                  {LabelToText[selected as ScheduleType]}
                </Box>
              )}
            >
              {Object.values(ScheduleType).map((value) => (
                <MenuItem key={value} value={value} onClick={() => setSelectedLabel(value)}>
                  <span
                    style={{
                      display: 'inline-block',
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      backgroundColor: RegionOfInterestColors[value] || 'white',
                      marginRight: '10px',
                    }}
                  />
                  <ListItemText primary={LabelToText[value]} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </>
    )
  }
  